import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { SettingsTabId } from "@/store/pages/SettingsPageStore";
import { NotesListPageCalendarSyncStatusView } from "./notes-list-page-calendar-sync-status.view";

/**
 * Displays calendar sync status when there are failed or retrying calendars.
 * Connects to the MobX store and renders the view component.
 */
export const NotesListPageCalendarSyncStatus = observer(() => {
  const { store } = useAppStore();
  const failedOrRetryingCalendars = store.spaceAccountCalendars.failedOrRetryingCalendars;

  if (failedOrRetryingCalendars.length === 0) {
    return null;
  }

  const firstCalendar = failedOrRetryingCalendars[0];
  const additionalCount = failedOrRetryingCalendars.length - 1;
  // Calendars are already sorted by worst status first (FAILED, then TRYING_TO_CONNECT)
  const worstStatus = firstCalendar.calendarSyncStatus;

  if (!worstStatus) {
    return null;
  }

  return (
    <NotesListPageCalendarSyncStatusView
      status={worstStatus}
      calendarLabel={firstCalendar.primaryLabel ?? ""}
      calendarColor={firstCalendar.color}
      additionalCount={additionalCount}
      onClick={() => store.settingsModal.open(SettingsTabId.CalendarAndMeetingsPage)}
    />
  );
});
